<template>
  <div class="soft">
    <div class="drag-info">
      <div class="drag-info-content centered">
        <img src="/static/img/icons/move.svg" class="drag-icon" />
        <p class="has-text-centered">
        Чтобы поменять местами элементы удерживайте и перетаскивайте их <br>
        </p>
      </div>
    </div>
    <h2 class="has-text-centered">Софт</h2>
    <draggable class="data-container columns is-multiline" @end="dragSoftsEnd" v-model="softObject">
      <SoftItem v-for="item in softObject" :key="item.id" :data="item" />
    </draggable>
    <div class="centered">
      <span class="button-wrapper" @click="handleAddDataForClients('software')">
        <a class="button is-info">+</a>Добавить ПО
      </span>
    </div>
    <h2 class="has-text-centered">Инструкции</h2>
    <draggable class="data-container columns is-multiline" @end="dragInstructionEnd" v-model="instructionsObject">
      <SoftItem v-for="item in instructionsObject" :key="item.id" :data="item" />
    </draggable>
    <div class="centered">
      <span class="button-wrapper" @click="handleAddDataForClients('instruction')">
        <a class="button is-info">+</a>Добавить инструкцию
      </span>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import deepcopy from 'deepcopy'
  import SoftItem from 'components/About/SoftItem'
  import draggable from 'vuedraggable'
  import uuidv4 from 'uuid/v4'

  export default {
    name: 'DataForClients',
    data () {
      return {
        softObject: [],
        instructionsObject: []
      }
    },
    computed: {
      ...mapState(['dataForClients'])
    },
    created () {
      this.getDataForClients()
    },
    methods: {
      ...mapActions(['getDataForClients', 'addDataForClients', 'updateDataForClientsOrder']),
      dragSoftsEnd () {
        for (let i = 0; i < this.softObject.length; i++) {
          this.softObject[i].order = i
        }
        this.updateDataForClientsOrder(this.softObject)
      },
      dragInstructionEnd () {
        for (let i = 0; i < this.instructionsObject.length; i++) {
          this.instructionsObject[i].order = i
        }
        this.updateDataForClientsOrder(this.instructionsObject)
      },
      handleAddDataForClients (type) {
        this.addDataForClients({
          id: uuidv4(),
          order: this.dataForClients.length + 1,
          type
        })
      }
    },
    components: { SoftItem, draggable },
    watch: {
      dataForClients: {
        deep: true,
        handler (value) {
          this.softObject = deepcopy(value.filter(s => s.type === 'software'))
          this.instructionsObject = deepcopy(value.filter(s => s.type === 'instruction'))
        }
      }
    }
  }
</script>

<style scoped>
.data-container {
  max-width: 1000px;
  margin: 0 auto;
}
.drag-info {
  margin: 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// DataForClients.vue?63b88422